import GoalError from './GoalError';
class GoalNotFound extends GoalError {
    constructor(goalId, options) {
        super(`The goal with id ${goalId} was not found`, options);
    }
}
export default GoalNotFound;
